import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, Divider, Paper } from "@mui/material";
import {
    BreadCrumbs,
    PageTitleWithToolTip,
    Input,
    Select,
    PrimaryButton,
    SecondaryButton,
    LoadingBar
} from "../../Common";
import Routes from '../../../routes';
import toast from 'react-hot-toast';
import useNavigate from '../../../hooks/useNavigate';
import { Grey2 } from '../../../color_utils';

const AddManufacturer = () => {
    const navigate = useNavigate({ pageName: 'AddManufacturer' });
    const [loading, setLoading] = useState(true);
    const [name, setName] = useState('');
    const [instanceId, setInstanceId] = useState(0);
    const [instanceOptions, setInstanceOptions] = useState([]);
    const [errorObject, setErrorObject] = useState({});

    useEffect(() => {
        const fetchDropdowns = async () => {
            const response = await fetch(Routes.Manufacturers.AddManufacturerDropdowns());
            if (response.status === 200) {
                const data = await response.json();
                const globalOption = { id: 0, name: "Global" };
                setInstanceOptions([globalOption, ...data.instances]);
            }
            setLoading(false);
        };
        fetchDropdowns();
    }, []);

    const validateFields = () => {
        const errors = {};
        let isValid = true;

        if (!name || !name.trim()) {
            errors.name = true;
        }

        setErrorObject(errors);
        if (Object.values(errors).some(state => state === true || typeof state === 'string')) {
            isValid = false;
        }
        return isValid;
    };

    const handleCreate = async () => {
        if (!validateFields()) return;

        const response = await fetch(Routes.Manufacturers.Create(), {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                Name: name.trim(),
                InstanceId: instanceId
            })
        });

        if (response.status === 200) {
            toast.success('The Manufacturer has been successfully created.', { duration: 6000 });
            navigate.push('/Manufacturers');
            return;
        }

        if (response.status === 400) {
            const errors = await response.json();
            if (errors && errors.length > 0) {
                toast.error(errors[0].exceptionMessage, { duration: 6000 });
                return;
            }
        }

        toast.error('There was an error creating the Manufacturer. Please try again.', { duration: 6000 });
    };

    if (loading) {
        return <LoadingBar />;
    }

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: 'Geek Command Center', to: '/GeekCommandCenter' },
                    { text: 'Manufacturers', to: '/Manufacturers' },
                    { text: 'Add Manufacturer' }
                ]}
            />
            <PageTitleWithToolTip pageTitle="Add Manufacturer" />
            <Paper
                elevation={0}
                sx={{
                    backgroundColor: '#fafafa',
                    p: 4,
                    mt: 2
                }}
            >
                <Typography
                    variant="h5"
                    align="center"
                    sx={{ mb: 2, color: Grey2 }}
                >
                    Add Manufacturer
                </Typography>
                <Divider sx={{ mb: 4 }} />
                <Grid container justifyContent="center">
                    <Grid item xs={12} md={8} lg={6}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Input
                                    fullWidth
                                    required
                                    variant="standard"
                                    label="Manufacturer Name"
                                    placeholder="Enter manufacturer name"
                                    value={name}
                                    error={errorObject.name}
                                    onChange={e => setName(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Select
                                    label="Instance"
                                    options={instanceOptions}
                                    onChange={e => setInstanceId(e.target.value)}
                                    variant="standard"
                                    value={instanceId}
                                    sx={{ width: '100%' }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 4, mb: 4 }}>
                <SecondaryButton
                    buttonText="Cancel"
                    onClick={() => navigate.push('/Manufacturers')}
                />
                <PrimaryButton
                    buttonText="Create"
                    onClick={handleCreate}
                />
            </Box>
        </>
    );
};

export default AddManufacturer;
